import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

// "Where did you hear about us?" tallies from launch-list + account sign-ups.
export default function SourcesCard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/admin/store/sources").then((r) => setD(r.data)).catch(() => setErr(true)); }, []);
  if (err) return <div data-testid="sources-error" className="mt-8 text-sm text-[#F87171]">Couldn't load where people found you - refresh to try again.</div>;
  if (!d) return <div data-testid="sources-loading" className="mt-8 text-sm text-[#64748B]">Loading where people found you…</div>;
  const max = Math.max(1, ...d.counts.map(([, n]) => n));
  return (
    <section data-testid="sources-card" className="mt-8 border border-blue-900/40 rounded-lg p-5 bg-[#0B0D14]">
      <h2 className="text-xl font-medium">Where people found you</h2>
      <p className="text-sm text-[#94A3B8] mt-1" data-testid="sources-answered">
        {d.answered} sign-up{d.answered === 1 ? "" : "s"} answered (optional question, people can tick more than one).
      </p>
      <div className="mt-4 space-y-2">
        {d.counts.map(([name, n]) => (
          <div key={name} className="flex items-center gap-3 text-sm" data-testid={`source-row-${name.toLowerCase().replace(/[^a-z]+/g, "-")}`}>
            <div className="w-44 text-[#CBD5E1] flex-shrink-0">{name}</div>
            <div className="flex-1 h-2.5 rounded bg-[#111827] overflow-hidden">
              <div className="h-full bg-[#FBBF24]" style={{ width: `${(n / max) * 100}%` }} />
            </div>
            <div className="w-10 text-right mono text-[#F1F5F9]">{n}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
